// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/section-bg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sections */
.oc-section {
  background-color: #f7f7f7;
  /* border-top-right-radius: 2.25rem; */
  /* padding: 3rem 1.625rem 0 0; */
}

.oc-section-title {
  font-family: DMSans-Bold;
  /* font-size: 2.875rem; */
  line-height: 3.375rem;
  color: #000;
  /* padding-left: 6.0625rem; */
  margin-bottom: 2.75rem;
}

.oc-section-inner {
  background-color: #efefef;
  /* border-top-right-radius: 2.25rem;
  padding: 3.125rem 4.1875rem 11.5625rem 6.0625rem; */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center left;
  background-size: cover;
  background-blend-mode: luminosity;
}
`, "",{"version":3,"sources":["webpack://./src/components/section/Section.css"],"names":[],"mappings":"AAAA,aAAa;AACb;EACE,yBAAyB;EACzB,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB;qDACmD;EACnD,yDAA2D;EAC3D,4BAA4B;EAC5B,gCAAgC;EAChC,sBAAsB;EACtB,iCAAiC;AACnC","sourcesContent":["/* Sections */\n.oc-section {\n  background-color: #f7f7f7;\n  /* border-top-right-radius: 2.25rem; */\n  /* padding: 3rem 1.625rem 0 0; */\n}\n\n.oc-section-title {\n  font-family: DMSans-Bold;\n  /* font-size: 2.875rem; */\n  line-height: 3.375rem;\n  color: #000;\n  /* padding-left: 6.0625rem; */\n  margin-bottom: 2.75rem;\n}\n\n.oc-section-inner {\n  background-color: #efefef;\n  /* border-top-right-radius: 2.25rem;\n  padding: 3.125rem 4.1875rem 11.5625rem 6.0625rem; */\n  background-image: url(\"../../assets/images/section-bg.svg\");\n  background-repeat: no-repeat;\n  background-position: center left;\n  background-size: cover;\n  background-blend-mode: luminosity;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
